import { api } from "@/scripts/helpers/api";

export const addUserToExperiment = async uid => {
  const response = await api.addUserToExperiment(uid);
  const userId = response?.data.attributes.uid;

  return userId !== "original";
};
